export default "__VITE_ASSET__B9pn_fqj__"